import React from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
} from 'react-router-dom';
import { FrontLayout } from '../components/layout';
/**
 * Imports App pages
 */
import PageNotFound from './PageNotFound';
import Landing from '../pages/landing/Landing';
// Customer pages
import MenuPage from '../pages/user/menu/MenuPage';
import Legal from '../pages/legal/Legal';
import PaymentResult from '../pages/payment/PaymentResult';

const AppRoutes = (props) => {
    return (
        <BrowserRouter {...props}>
            <Routes>
                {/*** Customer-facing layout (logo header + legal/cookie footer) ***/}
                <Route element={<FrontLayout />}>
                    {/* Bare "/" has no venue context — the app is reached via a QR code
                        deep-link (/user/dashboard/:token). Show a friendly landing,
                        NOT the old owner-login (that flow lives in the separate owner app). */}
                    <Route index element={<Landing />} />
                    <Route path='/user/dashboard/:token' element={<MenuPage />} />
                    <Route path='/legal/:page' element={<Legal />} />
                    <Route path='/payment-success' element={<PaymentResult />} />
                    <Route path='/payment-cancelled' element={<PaymentResult />} />
                    {/* Catch-all: needs path="*" or it never matches (was a no-op blank page). */}
                    <Route path='*' element={<PageNotFound />} />
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

export default AppRoutes;
